import './style/bluemateBadge.scss';

import classNames from 'classnames';

import React, {ReactNode} from 'react';

import BluemateTooltip from '../tooltip/bluemateTooltip';

export type BluemateBadgeColor = 'blue' | 'green' | 'red' | 'orange' | 'gold' | 'gray';
export type BluemateBadgeSize = 'small' | 'normal' | 'big';

interface Props {
    label: ReactNode;
    color?: BluemateBadgeColor;
    size?: BluemateBadgeSize;
    /** Pale tinted fill + subtle coloured border + coloured content, instead of
     * the solid fill. Colour follows the `color` prop. Defaults to false. */
    outline?: boolean;
    tooltip?: ReactNode;
    /** Extra class on the tooltip portal element (e.g. to allow wrapping). */
    tooltipClassName?: string;
    /** Keep the tooltip open while hovered, so links inside stay clickable. */
    tooltipInteractive?: boolean;
    onClick?: VoidFunction;
    className?: string;
}

export default function BluemateBadge(props: Props) {
    const {
        label,
        color = 'blue',
        size = 'normal',
        outline = false,
        tooltip,
        tooltipClassName,
        tooltipInteractive,
        onClick,
        className
    } = props;

    const element = (
        <span
            className={classNames(
                'bluemate-badge',
                `color-${color}`,
                `size-${size}`,
                outline && 'outline',
                onClick && 'clickable',
                className
            )}
            onClick={onClick}
        >
            {label}
        </span>
    );

    if (tooltip) {
        return (
            <BluemateTooltip text={tooltip} className={tooltipClassName} interactive={tooltipInteractive}>
                {element}
            </BluemateTooltip>
        );
    }

    return element;
}
